
export default [
    {
        path: '/admin/incentive-bonus-items',
        name: 'incentive-bonus-items',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/item-incentive-bonu/index.vue')
    }
]